import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";

const XLSX_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const extractMessage = async (blob) => {
  try {
    const text = await blob.text();
    try {
      const parsed = JSON.parse(text);
      return (
        parsed?.ResponseDescription ||
        parsed?.responseDescription ||
        parsed?.message ||
        parsed?.title ||
        text
      );
    } catch (_) {
      return text || "Download failed";
    }
  } catch (_) {
    return "Download failed";
  }
};

const parseFileNameFromHeaders = (headers) => {
  if (!headers) return null;
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"];
  if (!disposition) return null;
  const filenameStar = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (filenameStar) {
    try {
      return decodeURIComponent(filenameStar[1]);
    } catch (_) {
      return filenameStar[1];
    }
  }
  const filename = disposition.match(/filename="?([^";]+)"?/i);
  return filename ? filename[1].trim() : null;
};

export const downloadXLSX = async (eventId) => {
  try {
    const response = await httpRequest(
      `${BASE_URL}/Report/DownloadEventRegistrationReportV2/${eventId}`,
      "post",
      null,
      {
        responseType: "blob",
        timeout: 0,
      }
    );

    const headers = response?.headers || {};
    const data = response?.data ?? response;

    if (!data) {
      throw new Error("Download failed: no response");
    }

    if (!(data instanceof Blob)) {
      if (data?.response?.data instanceof Blob) {
        const message = await extractMessage(data.response.data);
        throw new Error(message);
      }
      throw new Error("Download failed");
    }

    if (data.size === 0) {
      throw new Error("Download failed: empty file");
    }

    const contentType = (data.type || headers["content-type"] || "")
      .toLowerCase();
    const looksLikeError =
      contentType.includes("application/json") ||
      contentType.includes("text/html") ||
      contentType.includes("text/plain");

    if (looksLikeError) {
      const message = await extractMessage(data);
      throw new Error(message);
    }

    const serverFileName = parseFileNameFromHeaders(headers);
    const isCsv = contentType.includes("text/csv") || contentType.includes("csv");

    return {
      blob: data,
      isCsv,
      contentType: isCsv ? "text/csv;charset=utf-8" : XLSX_TYPE,
      fileName:
        serverFileName ||
        (isCsv ? `Delegates_${eventId}.csv` : `EventReport_${eventId}.xlsx`),
    };
  } catch (error) {
    console.error("Download error:", error);
    throw error;
  }
};

export const downloadAttendanceReport = async (payload) => {
  try {
    const response = await httpRequest(
      `${BASE_URL}/Report/DownloadAttendanceReport`,
      "post",
      payload,
      {
        responseType: "blob",
        timeout: 0,
      }
    );

    const headers = response?.headers || {};
    const data = response?.data ?? response;

    if (!data) {
      throw new Error("Download failed: no response");
    }

    if (!(data instanceof Blob)) {
      if (data?.response?.data instanceof Blob) {
        const message = await extractMessage(data.response.data);
        throw new Error(message);
      }
      throw new Error("Download failed");
    }

    if (data.size === 0) {
      throw new Error("Download failed: empty file");
    }

    const contentType = (data.type || headers["content-type"] || "").toLowerCase();
    const looksLikeError =
      contentType.includes("application/json") ||
      contentType.includes("text/html") ||
      contentType.includes("text/plain");

    if (looksLikeError) {
      const message = await extractMessage(data);
      throw new Error(message);
    }

    const serverFileName = parseFileNameFromHeaders(headers);
    const isCsv = contentType.includes("text/csv") || contentType.includes("csv");
    const eventId = payload?.eventId || "All";

    return {
      blob: data,
      isCsv,
      contentType: isCsv ? "text/csv;charset=utf-8" : XLSX_TYPE,
      fileName:
        serverFileName ||
        (isCsv
          ? `AttendanceReport_${eventId}.csv`
          : `AttendanceReport_${eventId}.xlsx`),
    };
  } catch (error) {
    console.error("Download attendance report error:", error);
    throw error;
  }
};

